/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Sign_In_MsgInputs */



/**
* | output |
* | --- |
* | "Please sign in to view your profile." |
*
* @param {Profile_Sign_In_MsgInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_sign_in_msg = /** @type {((inputs?: Profile_Sign_In_MsgInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Sign_In_MsgInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez vous connecter pour voir votre profil.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por favor, inicie sesión para ver su perfil.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Por favor, faça login para ver seu perfil.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Effettua l'accesso per visualizzare il tuo profilo.")
	return /** @type {LocalizedString} */ ("Please sign in to view your profile.")
});